import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const rfidItemCardSx = {
    menuBtnText: {
        width: '100%',
        textAlign: 'start',
        fontSize: theme.spacing(14 / 8),
        fontWeight: 400,
        color: theme.palette.neutral[400],
    },
    popover: {
        '& .MuiPaper-root': {
            maxWidth: theme.spacing(200 / 8),
            width: '100%',
            p: 1,
        },
    },
};
